import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './scss/main.scss';

const rootElement = document.getElementById('root');

if (!rootElement) {
	throw new Error(
		"Root element not found. Ensure an element with id 'root' exists in your index.html."
	);
}

const root = ReactDOM.createRoot(rootElement);

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
